import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path, Rect } from "react-native-svg";

export const IconPeopleIdCard2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPeopleIdCard2"><Path d="M9.75 4.5H5L5 20.5H19V4.5H14.25" stroke="currentColor"/><Rect x="9.5" y="2.5" width="5" height="5" stroke="currentColor"/><Path d="M8 20.5C8 18.2909 9.79086 16.5 12 16.5C14.2091 16.5 16 18.2909 16 20.5" stroke="currentColor"/><Circle cx="12" cy="12.25" r="2.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconPeopleIdCard2;
